import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import HomeUpcomingFixture from "../common/HomeUpcomingFixture";
import 'swiper/css/navigation';
import { Link, useNavigate } from "react-router";
import HmeTopWinner from "../common/HmeTopWinner";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";
import { useTranslation } from "react-i18next";
import { AccordionItem, ControlledAccordion, useAccordionProvider } from '@szhsin/react-accordion';
import SettingPopup from "../common/SettingPopup";
import Notification from "../common/Notification";

export default function NewHome() {
  const { t, i18n } = useTranslation();
const providerValue = useAccordionProvider({
    allowMultiple: true,
    transition: true,
    transitionTimeout: 250
  });
  const { toggle, toggleAll } = providerValue;
    const [isOpenProfile1, setIsOpenProfile1] = useState(false);
 const accordionRef1 = useRef(null);

  const { setCurrentTheme,setIsBannerOpen,setLoginPop, isLoggedIn, loggedIn, isLoggedOut, setAlertMsg, openSuccessPopup, openErrorPopup, setLoading, setStackList, setMobileMenu, isMobileMenuOpen } = useContext(GlobalContext);
  const navigate = useNavigate();

  // useEffect(() => {
  //       document.body.classList.add("home-ver1");
  //       return () => {
  //           document.body.classList.remove("home-ver1");
  //       };
  //     }, []);


    const [assetsData, setAssetsData] = useState(null);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              'whiteLabelName': config.WhiteLable,
            }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          setAssetsData(data);
        } catch (error) {
          console.error('Fetch error:', error);
        }
      };

      fetchData();
    }, []);

      useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [isOpenProfile1]);

      const handleClickOutside = (event) => {
        console.log('Clicked:', event.target);

        if (accordionRef1.current && !accordionRef1.current.contains(event.target)) {
          console.log('Closing accordion 1');
          setIsOpenProfile1(false);
          toggle('item-1', false);
        }
      };

  useEffect(() => {
    document.body.classList.add("home");
    return () => {
      document.body.classList.remove("home");
    };
  }, []);

  const demoHandleClick = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/userLoginworld`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: "Demo" }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        // console.log('Login success:', data);
        if (data.token && data.user && data.sessionId) {
          localStorage.setItem('bannerOpen',false)
          config.bannerOpen = false;
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("sessionId", data.sessionId);
          sessionStorage.setItem("userinfo", JSON.stringify(data.user));
          sessionStorage.setItem("issecureauthenable", data.user?.issecureauthenable ? data.user?.issecureauthenable : false);
          sessionStorage.setItem("userId", data.user._id)
          sessionStorage.setItem("loggedIn", "true");
          isLoggedIn();
          window.location.replace("/sport");
          openSuccessPopup();
          setAlertMsg("Login Successful!");
          isLoggedIn();
          // setIsBannerOpen(true);
        } else {
          setAlertMsg(data.message)
          openErrorPopup();
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  };

const lightTheme = () => {
  localStorage.setItem('theme','light');
  setCurrentTheme('light');
  config.currentTheme = 'light';
  window.location.reload();
  }

  const darkTheme = () =>{
    localStorage.setItem('theme','dark');
    setCurrentTheme('dark');
    config.currentTheme = 'dark';
    window.location.reload();
  }

  const checkData = () => {
    console.log(localStorage.getItem("theme"),"localStorage.getItem(theme)localStorage.getItem()");
  }

  const toggleAccordion1 = () => {
    setIsOpenProfile1((prev) => {
      const newState = !prev;
      toggle('item-1', newState); // Ensure correct toggle
      return newState;
    });
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="home-wraper">
      <div className="home-header">
        <div className="logo">
          <Link to="/">
            <img src={localStorage.getItem("logo")} loading="lazy" alt="" />
          </Link>
        </div>
        <div className="right-btn">
<SettingPopup />
        {/* <div class="setting-box-container">
        <div ref={accordionRef1}>
          <ControlledAccordion providerValue={providerValue}>
             <AccordionItem as="span"
                itemKey="item-1"
                open={isOpenProfile1}
                onClick={toggleAccordion1}
                header={
                <div data-toggle="collapse" data-target="#settings-toggle" class="setting-icon collapsed" aria-expanded="false">
          <i class="fas fa-cog"></i>
        </div>}>
                  <div id="settings-toggle" class="setting-box collapse">
          <div>
            <h4>{t('theme')}</h4>
            <div id="select-theme" class="collapse show setting-sub-box">
              <div class="language-switch">
                <div class={`${config.currentTheme === 'dark'? 'selected' :''}`} onClick={darkTheme}>
                  <span>{t('dark')}</span> <i class="fas fa-moon ml-2"></i>
                </div>
                <div class={`${config.currentTheme === 'light'? 'selected' :''}`} onClick={lightTheme}>
                  <span>{t('light')}</span> <i class="fas fa-sun ml-2"></i>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h4>{t('language')}</h4>
            <div id="select-language" class="collapse show setting-sub-box">
              <div class="language-list">
                <div class={`${i18n.language === "hi" ? 'selected' : '' }`} onClick={() => changeLanguage('hi')}>हिंदी</div>
                <div class={`${i18n.language=="en-US" || i18n.language === "en" ? 'selected' : '' }`} onClick={() => changeLanguage('en')}>English</div>
                <div class={`${i18n.language === "mr" ? 'selected' : '' }`} onClick={() => changeLanguage('mr')}>मराठी</div>
                <div class={`${i18n.language === "gu" ? 'selected' : '' }`} onClick={() => changeLanguage('gu')}>ગુજરાતી</div>
                <div class={`${i18n.language === "ta" ? 'selected' : '' }`} onClick={() => changeLanguage('ta')}>தமிழ்</div>
              </div>
            </div>
          </div>
        </div>
              </AccordionItem>
          </ControlledAccordion>
        </div>
    </div> */}

          <button className="btn" onClick={() => setLoginPop(true)}>{t('login')}</button>
          <button className="btn mobile-hide" onClick={() => demoHandleClick()}>{t('demo')}</button>
        </div>
      </div>
      <div className="header-info desktop-hide flex home-header-info-mobile">
          <Notification />
          {/* <div className="news-bar">
            <marquee>All-time live casinos, Everyday Live sports, and Famous fantasy games are available on our exchange. Play to win big.</marquee>
            <div className="icon"> <img src="../images/speaker.svg" alt="news" /> </div>
          </div> */}
          <div className="right-btn">
            <SettingPopup />
          </div>
      </div>
      <HomeUpcomingFixture />
      <div className="home-slider">
        <Swiper
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          navigation={true}
          loop={true}
          modules={[Autoplay, Navigation]}
          className="home-banner-slider"
        >
        {assetsData?.banner?.map((item, index) => (
          <SwiperSlide key={index}> <img src={item.bannerName} alt="" /> </SwiperSlide>
        ))}
        </Swiper>
      </div>

      {assetsData && assetsData?.slider.map((slider,indexs)=>(
        <div className="home-casino-list" key={indexs} id={indexs}>
            <div className="home-sport-title">{slider.name}</div>
            <div className={`casino-grid ${slider.name.toString() == 'LIVE CASINOS' ? 'col-grid-8' :''}`}>
            {slider.images?.map((item, index) => (
              <Link className="game-img" id={index} key={index}>
                <img src={`https://image.maruti.dev/${config.WhiteLable}/sliderImages/${item.name}.webp`} alt={item.name} />
                {slider.name.toString() === 'our live casinos' ? <button className="loginbtn" role="button" onClick={() => setLoginPop(true)} tabindex={index}>{t('login')}</button> :''}
              </Link>
            ))}
            </div>
        </div>
      ))}
      <div className="home-casino-list">
        <div className="home-sport-title">{t('Top Winner')}</div>
        <HmeTopWinner />
      </div>
    </div>
  );
}
